// src/components/SuccessionDossierButton.jsx
// Bouton « Dossier de succession » (§4 TRANSMIT / §12) au niveau collection.
// Charge œuvres (artworks_secure, RLS) + attributions (artwork_beneficiary → beneficiaries)
// puis génère le PDF préparatoire. i18n à faire (FR pour l'instant).
import React, { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { generateSuccessionDossier } from "../utils/successionDossierPdf";

export default function SuccessionDossierButton({ collectionId, collectionName = "", ownerName = "", className = "" }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!collectionId || busy) return;
    setBusy(true);
    try {
      const { data: artworks, error: aErr } = await supabase
        .from("artworks_secure")
        .select("id,title,artist,current_estimated_value,valuation_estimated_value,estimated_value,value,ownership_status,is_exceptional")
        .eq("collection_id", collectionId);
      if (aErr) throw aErr;

      const ids = (artworks || []).map((a) => a.id);
      const benByArtwork = {};
      if (ids.length) {
        const { data: links } = await supabase
          .from("artwork_beneficiary")
          .select("artwork_id, beneficiary_id")
          .in("artwork_id", ids);

        const benIds = [...new Set((links || []).map((l) => l.beneficiary_id).filter(Boolean))];
        let benById = {};
        if (benIds.length) {
          const { data: bens } = await supabase
            .from("beneficiaries")
            .select("id, name, relation")
            .in("id", benIds);
          benById = Object.fromEntries((bens || []).map((b) => [b.id, b]));
        }
        for (const l of links || []) {
          const b = benById[l.beneficiary_id];
          if (!b) continue;
          (benByArtwork[l.artwork_id] ||= []).push({ name: b.name || "—", relation: b.relation || "" });
        }
      }

      generateSuccessionDossier({ collectionName, ownerName, artworks: artworks || [], benByArtwork });
    } catch (e) {
      console.error("[SuccessionDossierButton]", e);
      window.alert("Impossible de générer le dossier de succession.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy || !collectionId}
      title="Générer un dossier préparatoire de transmission (inventaire, détention, bénéficiaires)"
      className={className || "inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 disabled:opacity-60"}
    >
      {busy ? "Préparation…" : "Dossier de succession (PDF)"}
    </button>
  );
}
